import React, { useState, useEffect } from 'react';
import style from './style.module.scss';
import Modal from '../../../../components/modal';
import { getFiles, submitAdditionalDocuments } from '../../../../../api';
import FileIcon from '../../../../../v2/assets/svg/icons/common/file';
import Checkbox from '../../../../components/Checkbox/Index';
import Spinner from '../../../../components/Loaders/Spinner';
import moment from "moment";
import Button from '../../../../components/new-button';
import toast from 'react-hot-toast';

const SubmitAdditionalDocuments = ({
  open,
  onClose,
  appData,
}) => {

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [signedFiles, setSignedFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedUploadedFiles, setSelectedUploadedFiles] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    getFiles({
      id: appData.id,
    }).then((res) => {
      if (res.status) {
        setSignedFiles(res.files);
        setUploadedFiles(res.uploads);
      }
    })
      .catch(err => {

      })
      .finally(() => {
        setIsLoading(false);
      })
  }, []);

  const handleSubmit = () => {

    // check if selectedFiles is empty
    if (selectedFiles.length === 0 && selectedUploadedFiles.length === 0) {
      toast.error('Please select at least one of the signed documents or uploaded documents');
      return;
    }

    setIsSubmitting(true);

    const data = {
      editslug: appData.editslug,
      signedFiles: selectedFiles,
      uploadedFiles: selectedUploadedFiles,
    }

    submitAdditionalDocuments(data).then((res) => {
      if (res.status) {
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    }).catch((err) => {
      toast.error(err.message);
    }).finally(() => {
      setIsSubmitting(false);
      onClose();
    });
  }

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      header=""
      size="md"
    >
      <div className={style.container}>
        <div className={style.header}>
          <h5 className={style.title}>Submit Additional Documents</h5>
        </div>

        <div className={style.content}>
          <h6 className={style.subtitle}>Select the documents you want to submit</h6>
          {isLoading && (
            <div className={style.loadingContainer}>
              <Spinner />
            </div>
          )}

          {!isLoading && (
            <>
              <div className={style.filesContainer}>
                <p className={style.filesTitle}>Signed Documents</p>
                <div className={style.filesList}>
                  {signedFiles.map((file, index) => (
                    <label htmlFor={`signed-${file.name}`} className={style.fileItem} key={index}>
                      <Checkbox
                        id={`signed-${file.name}`}
                        value={file.name}
                        onChange={() => {
                          if (selectedFiles.includes(file.name)) {
                            setSelectedFiles(selectedFiles.filter(name => name !== file.name));
                          } else {
                            setSelectedFiles([...selectedFiles, file.name]);
                          }
                        }}
                        checked={selectedFiles.includes(file.name)}
                      />
                      <div className={style.fileContent}>
                        <FileIcon />
                        <p className={style.fileName}>{file.name}</p>
                      </div>
                    </label>
                  ))}
                </div>
              </div>

              <div className={style.filesContainer}>
                <p className={style.filesTitle}>Uploaded Documents</p>
                <div className={style.filesList}>
                  {uploadedFiles.map((file) => (
                    <label
                      htmlFor={`uploaded-${file.id}`}
                      className={style.fileItem}
                      key={file.id}
                    >
                      <Checkbox
                        id={`uploaded-${file.id}`}
                        value={file.file}
                        onChange={() => {
                          if (selectedUploadedFiles.includes(file.id)) {
                            setSelectedUploadedFiles(selectedUploadedFiles.filter(id => id !== file.id));
                          } else {
                            setSelectedUploadedFiles([...selectedUploadedFiles, file.id]);
                          }
                        }}
                        checked={selectedUploadedFiles.includes(file.id)}
                      />
                      <div className={style.fileContent}>
                        <FileIcon />
                        <p className={style.fileName}>
                          {file.file} - {file.title} -{" "}
                          {moment(file.created_at).format("MMM D, YYYY | H:mm A")}
                        </p>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            </>
          )}

        </div>


        <div className={style.footer}>
          <Button
            variant="ghost"
            onClick={onClose}
          >
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
            isLoading={isSubmitting}
          >
            Submit
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default SubmitAdditionalDocuments